/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useSpinnersContext } from "../../contexts/spinnersContext";

/* Components */
import Spinner from "../spinners/buttonSpinner";

/* Styles */
import styles from "./styles.js"

const UCSearch = props => {
  const { icon, className = "", placeholder = "", onChange, onClick, inputClassName, disabled, autocomplete, name, spinner, clearButton, showClearButton, inputRef, onKeyDown, onIconClick } = props;

  const theme = useTheme();
  const classes = styles({ theme });
  const spinners = useSpinnersContext();

  return (
    <div className={`${classes.inputWrapper} ${className}`}>
      {
        spinners[spinner?.name] ? 
          <Spinner size={spinner['size']} color={spinner['color']} customClass={classes.spinner}/>
         : icon && <span className={classes.icon} onClick={() => onIconClick && onIconClick(inputRef)}>{ icon }</span>
      }
      {
        showClearButton && clearButton 
      }
      { 
        <input className={`${classes.input} ${inputClassName}`} placeholder={placeholder} onChange={onChange} onClick={onClick} disabled={disabled} autoComplete={autocomplete} name={name} ref={inputRef} onKeyDown={onKeyDown}/>
      }
    </div>
  )
}

export default UCSearch;